module.exports = __webpack_public_path__ + "8ba450d280b444a0a86f3e724aba44d1.jpg";